import {schedule} from '@/services/MockData/Dropdown/schedule';
import {
  rewardSegments,
  bonusProducts
} from '@/services/MockData/Dropdown/rewards';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';

export const DROPDOWN_CONFIG = {
  ACTYVITY_TYPE_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=activityType',
    method: HTTP_METHODS.GET
    // For testing: use mock so Pay by Points appears without backend support. Comment out to use real API.
    // mockData: activityTypeMock
  },
  ACTYVITY_TYPE_ORDER_TYPE: {
    endPoint: 'dropdown-config?dropdownName=orderType',
    method: HTTP_METHODS.GET
    // mockData: OrderType,
  },
  CUSTOMER_TYPE_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=customerType',
    method: HTTP_METHODS.GET
  },
  SALES_TYPE_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=salesTargetType',
    method: HTTP_METHODS.GET
    // mockData: salesTargetType,
  },
  STORE_SELECTOR_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=storeSelector',
    method: HTTP_METHODS.GET
    // mockData: storeSelector,
  },
  ACTIONS_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=bulkPointModifierActions',
    method: HTTP_METHODS.GET
    // mockData: actions,
  },
  SCHEDULE_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=schedule',
    method: HTTP_METHODS.GET,
    mockData: schedule
  },
  REWARDS_CATALOG_ACTION_LIST: {
    endPoint: 'dropdown-config?dropdownName=rewardCatalogAction',
    method: HTTP_METHODS.GET
  },
  REWARD_TYPES_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=rewardType',
    method: HTTP_METHODS.GET
  },
  REWARD_SEGMENTS_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=rewardSegments',
    method: HTTP_METHODS.GET,
    mockData: rewardSegments
  },
  BONUS_PRODUCTS_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=bonusProducts',
    method: HTTP_METHODS.GET,
    mockData: bonusProducts
  },
  VISA_CARD_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=visaCardType',
    method: HTTP_METHODS.GET
  }
};
